import styled from "styled-components/macro";
import { rem } from "polished";

import { Link } from "react-router-dom";

import { routes, SITE_TITLE } from "../../../constants";
import { colors } from "../../../styles/Styles.variables";

const PageLogo = props => (
  <StyledLogo to={routes.home.path} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247 28">
      <title>{SITE_TITLE} logo</title>
      <path
        d="M157.47 18.28a16.62 16.62 0 01.31-2.64L161 1.22h5.51l-3.17 14.46a9 9 0 00-.27 2.06c0 2.64 1.8 4.67 5.28 4.67 3.94 0 5.81-2.45 6.58-6l3.37-15.18h5.5l-3.36 15.3c-1.38 6.2-4.56 10.67-12.4 10.67-6.93-.01-10.57-3.6-10.57-8.92zm27.59 2.37a9.47 9.47 0 006.5 2.83c1.65 0 2.68-.88 2.68-1.95s-1.57-1.68-3.4-2.3c-2.64-.88-6-2.06-6-5.2s2.68-6.23 7.61-6.23a11 11 0 017.84 3l-2.45 3.06a7.67 7.67 0 00-5.47-2.37c-1.72 0-2.67.8-2.67 1.8s1.37 1.45 3.17 2.06c2.72.84 6.2 2 6.2 5.36 0 3.52-2.95 6.46-8 6.46a12.09 12.09 0 01-8.72-3.33zM212.72 7.8c4.7 0 8.3 3.1 8.3 8.26a12.1 12.1 0 01-.38 3H206.9v.46c0 1.57 1.65 3.83 5 3.83a8.29 8.29 0 004.72-1.35l1.53 3.33a12 12 0 01-6.54 1.91c-5.81 0-9.56-3.14-9.56-8.3A10.79 10.79 0 01212.72 7.8zm3.94 7.57c0-1.83-1.3-3.71-4.25-3.71a5.28 5.28 0 00-5 4.09h9.26zm24.18-14.15h4.9l-5.67 25.51h-4.89l.53-2.29a7 7 0 01-5.54 2.75c-4.21 0-7-2.75-7-7.65 0-5.58 3.44-11.74 9.75-11.74a7 7 0 015.89 2.9zm-8.53 21.65a5.52 5.52 0 004.25-2.18l1.44-6.43a5.11 5.11 0 00-4.32-2.14c-3.18 0-5.43 3-5.43 6.43a4 4 0 004.06 4.32z"
        fill="#b3b3b3"
      />
      <path
        d="M44.06 1.14l-5.28 25.68H25.61l2.05-9.95H16.21l-2 10H1L6.28 1.14h13.16l-1.92 9.37H29l1.92-9.37zM101 20.47l4-19.33H91.78L86.5 26.82h24.89l1.31-6.37zm50.42-19.34h-38.83l-1.31 6.36h12.81l-4 19.33h13.16l4-19.33h12.85zM68 .6c-12.19 0-23.42 6-25.06 13.45S49.85 27.5 62.05 27.5s23.42-6 25.06-13.45S80.19.6 68 .6zm5.9 13.45c-.66 4.27-5.17 7.73-10.09 7.73s-8.35-3.46-7.69-7.73 5.17-7.73 10.08-7.73 8.35 3.46 7.69 7.73zm79.9-12.53a1.93 1.93 0 00-.78.77 2.16 2.16 0 00-.28 1 2.13 2.13 0 00.28 1 2 2 0 00.77.77 2.1 2.1 0 002.06 0 2 2 0 00.77-.77 2.11 2.11 0 00.27-1 2.15 2.15 0 00-.27-1 1.93 1.93 0 00-.78-.77 2.06 2.06 0 00-2 0zm1.87.3a1.6 1.6 0 01.65.64 1.83 1.83 0 01.23.87 1.79 1.79 0 01-.23.86 1.58 1.58 0 01-.64.64 1.72 1.72 0 01-1.72 0 1.58 1.58 0 01-.64-.64 1.79 1.79 0 01-.23-.86 1.83 1.83 0 01.23-.87 1.6 1.6 0 01.65-.64 1.75 1.75 0 011.7 0zm-1.4 2.65v-.94h.21a.48.48 0 01.29.07 1.74 1.74 0 01.38.52l.2.35h.44l-.28-.47a2.62 2.62 0 00-.33-.45.56.56 0 00-.19-.11.73.73 0 00.47-.21.61.61 0 00.17-.42.56.56 0 00-.1-.33.53.53 0 00-.28-.21 1.61 1.61 0 00-.57-.07h-.77v2.27zm0-1.93h.41a1.25 1.25 0 01.36 0 .31.31 0 01.15.12.28.28 0 01.06.18.3.3 0 01-.11.24.66.66 0 01-.43.1h-.44z"
        fill="#fff"
      />
    </svg>
  </StyledLogo>
);

const StyledLogo = styled(Link)`
  color: ${colors.white};
  display: block;
  outline: ${rem("1px")} dotted transparent;
  text-decoration: none;

  &:focus {
    outline-color: ${colors.white};
  }

  svg {
    display: block;
  }
`;

export default PageLogo;
